import { ScatterChart } from "@mui/x-charts/ScatterChart";

const data = [
  { capacity: 50, speed: 10, quality: 60 },
  { capacity: 80, speed: 20, quality: 70 },
  { capacity: 120, speed: 30, quality: 75 },
  { capacity: 400, speed: 0, quality: 50 },
  { capacity: 1200, speed: 0, quality: 90 },
  { capacity: 30, speed: 60, quality: 85 },
  { capacity: 20, speed: 90, quality: 95 },
];

const CapacitySpeedQuality = () => {
  return (
    <ScatterChart
      height={300}
      series={[
        {
          data: data.map((d) => ({
            x: d.capacity,
            y: d.speed,
            z: d.quality, // bubble size
          })),
          label: "Venues",
        },
      ]}
      xAxis={[{ label: "capacity" }]}
      yAxis={[{ label: "internet_upload_speed" }]}
    />
  );
};

export default CapacitySpeedQuality;
